import React from 'react';
import './VersionFooter.css';

const VersionFooter = () => (
    <p className="version-footer">Version {process.env.REACT_APP_VERSION}</p>
);

export default VersionFooter;
